import axios from "axios";

const Axios = axios.create({
  baseURL:"https://bridgeserver.ohoswap.com/"

  
});

export default Axios;
